import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

const unsuccessfulRechargeSearchSchema = z.object({
  errorMsg: z.string().optional(),
  paymentType: z.string().optional(),
});

export const Route = createFileRoute(
  '/_auth/_layout_with_navbar/topup-not-successful',
)({
  validateSearch: zodValidator(unsuccessfulRechargeSearchSchema),
});
